// extracted by mini-css-extract-plugin
export default {"totals":"wrcA96","total":"Df2h4F","quote-total":"zExo9l","quoteTotal":"zExo9l","total-value":"HV3TLP","totalValue":"HV3TLP"};